import { ClipboardList, Loader2 } from 'lucide-react';

import SelectField from '../../../../components/Forms/Input/SelectField';

import { IBranchDropdown } from '../../../../types/branches/branchInterfaces';

interface OrdersHeaderProps {
  branches: IBranchDropdown[];
  branchId: number | '';
  loadingBranches: boolean;
  canPickBranch: boolean;
  onBranchChange: (branchId: number) => void;
}

const OrdersHeader = ({
  branches,
  branchId,
  loadingBranches,
  canPickBranch,
  onBranchChange,
}: OrdersHeaderProps) => {
  return (
    <div className="border-b border-stroke bg-white px-5 py-5 dark:border-strokedark dark:bg-boxdark sm:px-7">
      <div className="flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div className="flex items-start gap-3">
          <span className="rounded-xl border border-primary/15 bg-primary/10 p-3 text-primary">
            <ClipboardList className="h-6 w-6" />
          </span>

          <div>
            <p className="text-xs font-semibold uppercase tracking-wider text-primary">
              Servicio en mesa
            </p>

            <h1 className="mt-1 text-2xl font-bold text-black dark:text-white">
              Órdenes de restaurante
            </h1>

            <p className="mt-1 text-sm text-bodydark2 dark:text-bodydark">
              Abra mesas, prepare la orden y mantenga su estado operativo al
              día.
            </p>
          </div>
        </div>

        {canPickBranch && (
          <div className="w-full sm:w-90">
            {loadingBranches ? (
              <div className="flex h-[74px] items-center justify-center gap-2 text-sm text-bodydark2">
                <Loader2 className="h-4 w-4 animate-spin text-primary" />
                Cargando sucursales...
              </div>
            ) : (
              <SelectField
                label="Sucursal"
                name="orderBranch"
                value={branchId}
                iconKey="building"
                options={branches.map((branch) => ({
                  value: branch.id,
                  label: branch.name,
                }))}
                onChange={(event) => onBranchChange(Number(event.target.value))}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default OrdersHeader;
